import { createElement } from 'react';
import './index.scss';
import { bizCssPrefix } from '../../variables';
import { Input } from '@alifd/next';
const box = bizCssPrefix + '-colorful-text';
const ColorfulText = function ColorfulText(props) {
    const { title, description, type, children, dataSource } = props;
    console.log('dataSource', dataSource);
    const _dataSource = dataSource ? JSON.stringify(dataSource) : '';
    return (createElement("div", { className: [box] },
        children,
        createElement("h1", null, title),
        createElement("h2", null, description),
        createElement("h3", null, type),
        createElement("h3", null,
            "dataSource: ",
            _dataSource),
        dataSource ? createElement(Input, { value: dataSource.email }) : createElement("h4", null, "\u65E0")));
};
ColorfulText.displayName = 'ColorfulText';
ColorfulText.defaultProps = {
    title: 'this is title',
    description: 'this is a description',
};
export default ColorfulText;
